export const MOIS_FR = [
  "", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
];

export function chf(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("fr-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function periodeLabel(p) {
  if (!p) return "—";
  return `${MOIS_FR[Number(p.slice(5, 7))]} ${p.slice(0, 4)}`;
}

export function moisCourant() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export const STATUT_FICHE = {
  brouillon: { label: "Brouillon", cls: "bg-gray-100 text-gray-600 border-gray-200" },
  validee: { label: "Validée", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  comptabilisee: { label: "Comptabilisée", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const STATUT_DETTE = {
  ouverte: { label: "À payer", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  partielle: { label: "Partiellement payée", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  payee: { label: "Payée et rapprochée", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};
